export const PINTEREST_OVERVIEW_SINGLE_BRAND = [
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['PINTEREST'],
      metrics: ['TOTAL_FOLLOWERS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['PINTEREST'],
      metrics: ['IMPRESSIONS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['PINTEREST'],
      metrics: ['AVG_ENGAGEMENT_RATE'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['PINTEREST'],
      metrics: ['SAVES'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['PINTEREST'],
      metrics: ['CLOSEUPS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['PINTEREST'],
      metrics: ['LINK_CLICKS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 2,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['PINTEREST'],
      metric: 'NET_NEW_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 2,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['PINTEREST'],
      metric: 'SAVES',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 6,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['PINTEREST'],
      metric: 'LINK_CLICKS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 6,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['PINTEREST'],
      metric: 'IMPRESSIONS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 10,
    meta: {
      name: 'Pin Performance',
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 11,
    meta: {
      brand_ids: ['{brandId0}'],
      channel: 'PINTEREST',
      metric: 'ENGAGEMENT_RATE',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 15,
    meta: {
      brand_ids: ['{brandId0}'],
      channel: 'PINTEREST',
      metric: 'ENGAGEMENT_RATE',
      sort_order: 'ASC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
];
